import React from 'react';
import useCurrentUserActionLocked from "../../hooks/useCurrentUserActionLocked";

/*
const CtaCannot = ({
        children = null,
        isModal = false,
        action = "",
        openModal = () =>{},
        disabled = false
    }) =>{

    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const [togglePopup, setTogglePopup] = useState(false);

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    const clickCta = queryClient.getQueryData([USER_CURRENT_CLICK_CTA_KEY]);


    function _openModal(){
        if(!disabled){
            if(!togglePopup) setTogglePopup(true);
            openModal();
        }
    }

    let modal = clickCta && clickCta[action];

    return (
        clickCta && modal && isCurrentUser ? (
            isModal && modal &&  modal.modal ? (
                <>
                    <div onClick={() => _openModal()}>
                        {children}
                    </div>
                    {modal === EmailValidation ? <EmailValidation toggle={togglePopup} handleClose={() => setTogglePopup(false)} /> : (
                        <Modal toggle={togglePopup} handleClose={() => setTogglePopup(false)}>
                            <modal.modal username={dataCurrentUser.username} userId={dataCurrentUser._id} toggle={togglePopup} handleClose={() => setTogglePopup(false)} />
                        </Modal>
                    )}
                </>
            ) : (
                <div onClick={() => modal.to ? navigate(modal.to) : null}>
                    {children}
                </div>
            )
        ) : (
            <>
                <div onClick={() => navigate(createLink("signin"))}>
                    {children}
                </div>

            </>
        )
    )
};*/

const CtaCannot = ({
       children = null,
       action = "",
       isModal = false,
         ...props
   }) =>{

    const {handleLockedAction} = useCurrentUserActionLocked({action});

    return (
        <div {...props} onClick={() => handleLockedAction()}>
            {children}
        </div>
    )
};

export default CtaCannot;